import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getStopDetails(stopId) {
  const criteriaParams = {
    filters: [
      '*',
      'location.*',
      'stopType.*',
      'route.*',
      'route.actualComplete',
      'route.actualArrival',
      'cancelCode.*',
      'actualSequenceNum',
      'plannedSequenceNum',
      'size1AliasConfig.*',
      'size2AliasConfig.*',
      'size3AliasConfig.*'
    ],
    firstResult: 0,
    maxResults: 51
  };

  const payload = {
    criteriaChain: [
      {
        and: [
          {
            attr: 'id',
            eq: stopId
          }
        ]
      }
    ]
  };
  const url = `/Stop/restrictions?criteria=${encodeURI(
    JSON.stringify(criteriaParams)
  )}`;

  const response = await defaultFetch(url, payload, 'POST');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response[0] || [];
}

export const queryKey = ['stop-details'];

export function useStopDetails(stopId) {
  return useQuery({
    queryKey,
    staleTime: 1000 * 60, // 1 min
    queryFn: async () => {
      if (stopId) {
        return getStopDetails(stopId);
      }

      return [];
    }
  });
}
